import React from 'react';
import { Cpu, Radio, Monitor, Zap } from 'lucide-react';

const techItems = [
  {
    icon: Radio,
    title: 'FOIF A-90 DGPS (2 Nos.)',
    category: 'Satellite GNSS Surveying',
    specs: ['2 Units FOIF A-90 Smart GNSS Base & Rover', 'Multi-Constellation Satellite Tracking', 'Millimeter Real-Time Kinematic (RTK)', 'Instant WGS84 & UTM Grid Fixing'],
    desc: 'Dual FOIF A-90 DGPS systems deployed for highway alignments, solar pile marking, land plan schedules, and cadastral boundary verification.'
  },
  {
    icon: Zap,
    title: 'Leica Total Station (2 Nos.)',
    category: 'Swiss Precision Optical',
    specs: ['2 Units Leica High-Precision Total Stations', 'Sub-millimeter EDM Distance Measurement', 'MSL Benchmark Height Station Tying', 'High-Speed Angle & Elevation Reading'],
    desc: 'Swiss-engineered Leica Total Stations under active operation for high-level bridge alignment, culvert reconstruction, and level checking.'
  },
  {
    icon: Cpu,
    title: 'Sokkia Total Station (2 Nos.)',
    category: 'Japanese Precision Optical',
    specs: ['2 Units Sokkia Precision Total Stations', 'Pinpoint Laser Pointer & Reflectorless Measurement', 'Bridge Abutment & Pier Setting Out', 'Topographical Grid Contouring'],
    desc: 'Japanese Sokkia Total Stations utilized for NH highway corridor surveys, tank bund deepening DPRs, and DPR quantity checking.'
  },
  {
    icon: Monitor,
    title: 'AutoCAD & GIS Civil Software Suite',
    category: 'Digital CAD & Alignment Drafting',
    specs: ['AutoCAD Civil Engineering Suite', 'Bentley MicroStation DGN Alignment', 'NH & Highways Format Plan Plotting', 'L-Section & Cross-Section CAD Layering'],
    desc: 'Full digital CAD software ecosystem producing layered DWG, DXF, and PDF alignment plans matching NHAI, PWD, and Highways Department standards.'
  }
];

const Equipment = () => {
  return (
    <section id="equipment" className="section-padding" style={{ position: 'relative', background: '#f8fafc' }}>
      <div className="container">
        {/* Section Header */}
        <div className="section-title-wrapper">
          <div className="section-subtitle">Tech & Equipment</div>
          <h2 className="section-title">
            Digital Hardware & <span className="gradient-text">CAD Software Suite</span>
          </h2>
          <p className="section-desc">
            We deploy dual-frequency DGPS receivers, Leica total stations, and CAD software to deliver zero-error surveying reports.
          </p>
        </div>

        {/* Tech Cards Grid */}
        <div className="grid-2">
          {techItems.map((item, idx) => {
            const IconComp = item.icon;
            return (
              <div
                key={idx}
                className="glass-card"
                style={{
                  padding: '2.25rem',
                  display: 'flex',
                  gap: '1.5rem',
                  alignItems: 'flex-start',
                  background: '#ffffff',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)',
                }}
              >
                <div
                  style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, #fff5f5 0%, #eff6ff 100%)',
                    border: '1px solid #cbd5e1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#e63946',
                    flexShrink: 0,
                  }}
                >
                  <IconComp size={28} />
                </div>

                <div style={{ flex: 1 }}>
                  <div className="badge badge-red" style={{ fontSize: '0.75rem', marginBottom: '0.5rem' }}>
                    {item.category}
                  </div>
                  <h3 style={{ fontSize: '1.35rem', color: '#0f172a', marginBottom: '0.6rem' }}>
                    {item.title}
                  </h3>
                  <p style={{ color: '#475569', fontSize: '0.925rem', lineHeight: 1.6, marginBottom: '1.25rem' }}>
                    {item.desc}
                  </p>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.5rem' }}>
                    {item.specs.map((spec, sIdx) => (
                      <div key={sIdx} style={{ fontSize: '0.825rem', color: '#334155', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                        <div style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#e63946' }} />
                        {spec}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Equipment;
